import React from 'react';
import { TestimonialLayout } from './testimonials/TestimonialLayout';
import { TestimonialHeader } from './testimonials/TestimonialHeader';
import { TestimonialMetric } from './testimonials/TestimonialMetric';
import { TestimonialQuote } from './testimonials/TestimonialQuote';
import { Target, Activity, Brain } from 'lucide-react';
import { IMAGE_PATHS } from '@/utils/images';

const metrics = [
  {
    icon: Target,
    label: "Achievement Tracking",
    value: "90%",
    detail: "9 of 10 quarterly goals achieved",
    color: "text-neon-green"
  },
  {
    icon: Activity,
    label: "Wellness Integration",
    value: "75%",
    detail: "6 of 8 lifestyle habits established",
    color: "text-neon-purple"
  },
  {
    icon: Brain,
    label: "Career Development",
    value: "85%",
    detail: "17 of 20 skills mastered",
    color: "text-yellow-400"
  }
];

export const MayaTestimonial: React.FC = () => {
  return (
    <TestimonialLayout>
      <div className="relative">
        {/* Hero Image with Error Handling */}
        <div className="relative h-[80vh] overflow-hidden">
          <div className="absolute inset-0">
            <img 
              src={IMAGE_PATHS.MAYA_AVATAR}
              alt="Maya"
              className="w-full h-full object-cover object-top"
              onError={(e) => {
                const img = e.target as HTMLImageElement;
                img.onerror = null;
                img.src = IMAGE_PATHS.FALLBACK;
              }}
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />
        </div>

        {/* Content overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-12">
          <div className="max-w-7xl mx-auto">
            <div className="space-y-6 max-w-2xl">
              <TestimonialHeader 
                title="Meet Maya: A LifeTrack Success Story 🚀"
                subtitle="At 32, Maya is leveraging LIFETRACK to optimize her fast-paced New York lifestyle. Working in digital media and living in Brooklyn, she's found that LIFETRACK helps her balance career ambitions with personal growth."
              />

              <div className="grid grid-cols-3 gap-4">
                {metrics.map((metric) => (
                  <TestimonialMetric key={metric.label} {...metric} />
                ))}
              </div>

              <TestimonialQuote 
                quote="LIFETRACK has become an essential part of my daily routine. It helps me stay on top of my goals while maintaining the perfect work-life balance in the city that never sleeps."
                author="Maya"
              />
            </div>
          </div>
        </div>
      </div>
    </TestimonialLayout>
  );
};